import classNames from 'classnames';
import React from 'react';
import { FunctionComponent } from 'react';
import styles from './TrendingBanner.scss';
import { buildQuery, useFlags, usePageQuery } from '../../hooks';
import { gql } from '@apollo/client';
import { SupportersTrendFragment } from '../../../types/__generated__';
import { Trans, useTranslation } from 'react-i18next';

const FRAGMENT = buildQuery(gql`
  fragment SupportersTrend on Page {
    trend {
      count
      days
    }
  }
`);

const TrendingBanner: FunctionComponent = () => {
  const { showTrendingBanner } = useFlags();

  const { data, loading } = usePageQuery<SupportersTrendFragment>(FRAGMENT);
  const { t } = useTranslation('common', { useSuspense: false });

  const trend = data?.trend;

  return showTrendingBanner && !loading && (trend?.count ?? 0) >= 5 ? (
    <div className={classNames(`${styles.banner} jg-display-flex jg-flex-jcc`)}>
      <p className={styles.trendIcon}>
        <Trans i18nKey="trending.message" count={trend?.count ?? 0}>
          <strong>
            {{
              duration:
                trend?.days === 1
                  ? `24 ${t('trending.hours')}`
                  : t('trending.week'),
            }}
          </strong>
        </Trans>
      </p>
    </div>
  ) : null;
};

export default TrendingBanner;
